import { Component, output, viewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaButton } from '@rds-nova/angular-button';
import { SimpleDialogComponent } from '../simple-dialog/simple-dialog.component';

@Component({
  selector: 'app-exit-signing-modal',
  templateUrl: './exit-signing-modal.component.html',
  styleUrls: ['./exit-signing-modal.component.scss'],
  imports: [NovaButton, TranslatePipe, SimpleDialogComponent],
})
export class ExitSigningModalComponent {
  private readonly router = inject(Router);
  private readonly PREVIOUS_ROUTE_KEY = 'previousRoute';

  exitDialog = viewChild.required<SimpleDialogComponent>('exitDialog');
  
  modalClosed = output();

  open(): void {
    this.exitDialog().open();
  }

  close(): void {
    this.exitDialog().close();
    this.modalClosed.emit();
  }

  confirmExit(): void {
    const currentUrl = this.router.url;
    sessionStorage.setItem(this.PREVIOUS_ROUTE_KEY, currentUrl);
    
    this.close();
    this.router.navigate(['/exit-signing']);
  }
}